import nyNetwork from "@/api/nyBaseNetwork";
import DZModelInfo from "@/views/资讯管理/model/DZModelInfo";
import DZModelInfoType from "@/views/资讯管理/model/DZModelInfoType";
import DZModelInfoSearch from "@/views/资讯管理/model/DZModelInfoSearch";

class DZServiceInfo{

    list_info : Array<DZModelInfo> = [];

    list_type : Array<DZModelInfoType> = [];

    m_type = new DZModelInfoType();

    m_search = new DZModelInfoSearch();

    /** 分类 **/
    net_add_type(success: () => void){
        nyNetwork.net("添加资讯分类",this.m_type, data => {
            success()
        })
    }

    net_edit_type(success: () => void){
        nyNetwork.net("编辑资讯分类",this.m_type, data => {
            success()
        })
    }

    net_page_type(m_page){
        nyNetwork.net("资讯分类列表",m_page, data => {
            this.list_type = data.list
            this.m_search.total = data.total
        })
    }

    net_all_type(){
        nyNetwork.net("资讯分类所有",{}, data => {
            this.list_type = data
        })
    }

    net_delete_type(id,success: () => void){
        nyNetwork.net("删除资讯分类",{id:id}, data => {
            success()
        })
    }

    /** 资讯列表 **/
    net_page_list_info(m_search){
        nyNetwork.net("资讯分页列表",m_search, data => {
            this.list_info = data.list
            this.m_search.total = data.total
        })
    }

    net_add_info(m_info,success: () => void){
        nyNetwork.net("添加资讯",m_info, data => {
            success();
        })
    }

    net_edit_info(m_info,success: () => void){
        nyNetwork.net("编辑资讯",m_info, data => {
            success();
        })
    }

    net_del_info(id,success: () => void){
        nyNetwork.net("删除资讯",{id:id}, data => {
            success();
        })
    }


}
export default DZServiceInfo;